import type { Database } from './database';

export type StaffUser = Database['public']['Tables']['staff_users']['Row'];
export type StaffUserInsert = Database['public']['Tables']['staff_users']['Insert'];
export type StaffUserUpdate = Database['public']['Tables']['staff_users']['Update'];

export type StaffRole = StaffUser['role'];
export type StaffStatus = StaffUser['status'];

export type StaffActivityLog = Database['public']['Tables']['staff_activity_log']['Row'];
export type StaffActivityLogInsert = Database['public']['Tables']['staff_activity_log']['Insert'];

// Permissions type
export interface StaffPermissions {
  can_view_customers: boolean;
  can_edit_customers: boolean;
  can_create_cases: boolean;
  can_close_cases: boolean;
  can_send_sms: boolean;
  can_view_telemetry: boolean;
  can_manage_staff: boolean;
  can_configure_system: boolean;
}

// Activity action types
export type ActivityActionType =
  | 'view_customer'
  | 'edit_customer'
  | 'create_case'
  | 'update_case'
  | 'close_case'
  | 'assign_case'
  | 'add_case_note'
  | 'send_sms'
  | 'view_telemetry'
  | 'view_transaction'
  | 'export_data'
  | 'manage_staff'
  | 'update_settings';

// Entity types for activity log
export type EntityType =
  | 'customer'
  | 'case'
  | 'transaction'
  | 'sms'
  | 'staff_user'
  | 'setting';

// Extended staff user with full name helper
export interface StaffUserWithHelpers extends StaffUser {
  full_name: string;
}

export const getStaffFullName = (user: StaffUser): string => {
  return `${user.first_name} ${user.last_name}`;
};

export const getRoleDisplayName = (role: StaffRole): string => {
  const roleNames: Record<StaffRole, string> = {
    cs_rep: 'Customer Service Representative',
    relationship_manager: 'Relationship Manager',
    compliance_officer: 'Compliance Officer',
    operations_manager: 'Operations Manager',
    administrator: 'Administrator',
  };
  return roleNames[role];
};

export const getStatusDisplayName = (status: StaffStatus): string => {
  const statusNames: Record<StaffStatus, string> = {
    active: 'Active',
    inactive: 'Inactive',
    pending_approval: 'Pending Approval',
    suspended: 'Suspended',
  };
  return statusNames[status];
};

export const getStatusColor = (status: StaffStatus): string => {
  const colors: Record<StaffStatus, string> = {
    active: 'green',
    inactive: 'gray',
    pending_approval: 'orange',
    suspended: 'red',
  };
  return colors[status];
};

